<template>
    <div class="background-video-container">
        <video autoplay muted loop class="background-video">
            <source :src=videoSrc type="video/mp4" />
            Your browser does not support the video tag.
        </video>
        <!-- 用于展示页面内容的插槽 -->
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'videoBackground',
    props: ['videoSrc'],
}
</script>

<style scoped>
.background-video-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* 全屏视频 */
    overflow: hidden;
}

.background-video {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 确保视频覆盖整个背景 */
    transform: translate(-50%, -50%);
    z-index: 1;
    /* 视频置于底层 */
}

.content {
    height: 100%;
    position: relative;
    z-index: 2;
    /* 页面内容放置于视频上层 */
    color: #ffffff;
    /* 确保内容颜色在视频背景上清晰可见 */
}
</style>